module.exports = __webpack_public_path__ + "static/media/20180523-LCS-030-22.b728f335.jpg";